import React from 'react';

export function StepSourceSpecificationLabel() {
  return <>Specifikace zdroje</>;
}
